import styled from "styled-components"
import padding from "@irati/ui/src/global/padding"

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${padding.base} 0 ${padding.tiny};
`

export default HeaderWrapper
